// /m/{code} の SSR ページに載せる小さなバンドル（app/dist/home.js）。
// SPA（main.ts）は乗らないページなので、現住地の比較行だけをここで組み立てる。
// 計測は muniTrackingSnippet が定義した window.gtag に直接投げる。
import { isLang, DEFAULT_LANG } from "./i18n";
import { applyHome } from "./ui/home";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

function start(): void {
  const lang = document.documentElement.lang;
  applyHome(document, localStorage, isLang(lang) ? lang : DEFAULT_LANG, (event, params) => {
    window.gtag?.("event", event, params);
  });
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
else start();
